import axios from "axios";
import React, {useEffect, useRef, useState} from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import useThumbnailHandleS3 from "../../../../../../CustomHooks/useThumbnailHandleS3";
import useVdieoHandleS3 from "../../../../../../CustomHooks/useVideoHandleS3";
import Nav from "../../../../../../Layouts/Partial/PromoAdminNav";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";
import "./AddSessionTextEditor.css";
import useVideoHandleWithCompress from "../../../../../../CustomHooks/useVideoHandleWithCompress";

export default function AddSession() {
  const history = useHistory();
  const [starList, setStarList] = useState([]);
  const [loading, setLoading] = useState(false);

  // Video File Handle
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'promoVideos', videoDelKey);

  // Thumbnail File Handle
  const [thumbnail, setThumbnail] = useState('');
  const [thumbnailDelKey, setThumbnailDelKey] = useState(null);
  const [imageValidation, setImageValidation] = useState(false);
  const [videoValidation, setVideoValidation] = useState(false);
  const [thumbImageUrl,thumbImageKey,thumbProgress] = useThumbnailHandleS3(thumbnail, 'promoVideos/thumbnail', thumbnailDelKey);

  const [registerInput, setRegister] = useState({
    star_id: "",
    title: "",
    video_url: "",
    star_approval: "",
    status: "",
    error_list: [],
  });

    const requiredText= {
        color: 'red',
        fontSize: '12px',
    };

    // List of allowed file types
    const videoAllowedTypes = ['video/mp4', 'video/webm'];
    const allowedTypes = ['image/jpeg', 'image/png'];

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
    // e.persist();
    // setRegister({...registerInput, [e.target.name]: e.target.value});
  };

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
  }, []);

  const fileInputRef = useRef(null);
  const fileVideoInputRef = useRef(null);

  const handleVideoChange = (file2,event) => {
      const file = event.target.files[0];

      // Check if the selected file's type is in the allowedTypes array
      if (file && videoAllowedTypes.includes(file.type)) {
          setVideoDelKey(videoKey);
          setVideo(file2[0]);
          setVideoValidation(true);
      } else {
          // Display an error message or handle the validation error in some way
          swal("Invalid File Type", 'Please upload a valid video type(MP4, WebM).', "warning");
          fileVideoInputRef.current.value = null;
          setVideoValidation(false);
      }
  };

  const handleVideoThumbnailChange = (file,event) => {
    handleFileSelect(file,event);
  };


   const handleFileSelect = (file1,event) => {
        const file = event.target.files[0];

        // Check if the selected file's type is in the allowedTypes array
        if (file && allowedTypes.includes(file.type)) {
            setThumbnail(file1[0]);
            setThumbnailDelKey(thumbImageKey);
            setImageValidation(true)
        } else {
            // Display an error message or handle the validation error in some way
            swal("Invalid File Type", 'Please upload a valid image type(JPEG, PNG).', "warning");
            fileInputRef.current.value = null;
            setImageValidation(false)
        }
    };


  const promoSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();

    fData.append("star_id", registerInput.star_id);
    fData.append("title", registerInput.title);
    fData.append("video_url", videoKey);
    fData.append("thumbnail", thumbImageKey);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/promoVideo/store`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          // document.getElementById('input_form').reset();
          swal("Success", res.data.message, "success");
          history.push("/superstar-admin/pending/promoVideo");
        } else {
          //setModalShow(true);
          setRegister({
            ...registerInput,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  return (
    <>
      <Nav />
      <div
        className="my-4"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="Modal-js-body">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  className="p-3"
                  onSubmit={promoSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="form-group row my-4">
                    <label className="col-sm-3 col-form-label col-form-label-sm input-text-lv-ch">
                      Select Star <span style={requiredText} > *</span>
                    </label>

                    <div className="col-sm-9">
                      <select
                        required
                        onChange={handleInput}
                        name="star_id"
                        className="form-control reply-control"
                        value={registerInput.star_id}
                      >
                        <option className="text-black" value="">
                          --- Select Star ---
                        </option>

                        {starList.map((user, index) => (
                          <option className="text-black" value={user.id}>
                            {user.first_name} {user.last_name}
                          </option>
                        ))}
                      </select>
                      <small className="text-danger">
                        {registerInput.error_list?.star_id}
                      </small>
                    </div>
                  </div>
                  <div className="form-group row my-4">
                    <label className="col-sm-3 col-form-label col-form-label-sm input-text-lv-ch ">
                      Title <span style={requiredText} > *</span>
                    </label>
                    <div className="col-sm-9">
                      <input
                        required
                        type="text"
                        className="form-control reply-control"
                        placeholder="Enter title here...!"
                        onChange={handleInput}
                        name="title"
                        value={registerInput.title}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.title}
                      </span>
                    </div>
                  </div>
                  <div className="form-group row my-4">
                    <label
                      for="video_url"
                      className="col-sm-3 col-form-label col-form-label-sm input-text-lv-ch "
                    >
                      Upload Video <span style={requiredText} > *</span>
                    </label>
                    <div className="col-sm-9">
                      {(videoValidation && videoUrl ) ? (
                        <>
                          <ReactPlayer
                            url={videoUrl}
                            // width="100%"
                            controls={true}
                            height="35vh"
                          />
                        </>
                      ) : (
                        <></>
                      )}
                      <input
                        required
                        type="file"
                        className="form-control reply-control"
                        placeholder="Enter title here...!"
                        onChange={(e) => handleVideoChange(e.target.files,e)}
                        name="video_url"
                        ref={fileVideoInputRef}
                      />
                      {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                      <span className="text-danger">
                        {registerInput.error_list?.video_url}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label
                      for="thumbnail"
                      className="col-sm-3 col-form-label col-form-label-sm input-text-lv-ch "
                    >
                      Upload Video Thumbnail <span style={requiredText} > *</span>
                    </label>
                    <div className="col-sm-9">
                      {(imageValidation && thumbImageUrl ) ? (
                        <img
                          src={thumbImageUrl}
                          alt="..."
                          className="demo-preview-image img-fluid"
                        />
                      ) : (
                        ""
                      )}
                      <input
                        required
                        type="file"
                        className="form-control reply-control"
                        placeholder="Enter title here...!"
                        ref={fileInputRef}
                        onChange={(e) =>
                          handleVideoThumbnailChange(e.target.files,e)
                        }
                        name="thumbnail"
                      />
                      {thumbnail && !thumbImageUrl && <MediaUploadProgressBar progress={thumbProgress} />}
                      <span className="text-danger">
                        {registerInput.error_list?.thumbnail}
                      </span>
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
